import {BaseModel} from "../../_base/crud";

export class QuestionAnswerModel extends BaseModel{
    id: number;
    question: string;
    answer: string;
    questionType: string;
}
